import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksLeftSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 2H2v12h2V2zm1 2h10v3H5V4zm0 5h7v3H5V9z" />
  </svg>
);
export default IconAlignBlocksLeftSizeS;
